export const imageTextDefaultContent = {
    en: {
        imageText: {
            content: 'Mindfulness is the practice of being fully present, engaged in the current moment without judgment. It\'s about embracing each experience, good or bad, and finding peace within it.'
        },
    },
    es: {
        imageText: {
            content: 'La atención plena es la práctica de estar plenamente presente, involucrado en el momento actual sin juzgar. Se trata de aceptar cada experiencia, buena o mala, y encontrar la paz en ella.'
        }
    }
}
